import { render, staticRenderFns } from "./IgnorableErrorsModal.vue?vue&type=template&id=54b4f766&scoped=true&"
import script from "./IgnorableErrorsModal.vue?vue&type=script&lang=js&"
export * from "./IgnorableErrorsModal.vue?vue&type=script&lang=js&"
import style0 from "./IgnorableErrorsModal.vue?vue&type=style&index=0&id=54b4f766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4f766",
  null
  
)

export default component.exports